import React, { useState, useRef, useEffect } from 'react';

const UserDropdown = ({
	username,
	isIdle,
	audioOutputEnabled,
	audioInputEnabled,
	toggleAudioOutput,
	toggleAudioInput,
	onRequestOutput,
	onLeaveRoom,
	isRequestingOutput,
}) => {
	const [isOpen, setIsOpen] = useState(false);
	const dropdownRef = useRef(null);

	// Close dropdown when clicking outside
	useEffect(() => {
		const handleClickOutside = (event) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				setIsOpen(false);
			}
		};

		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);

	const toggleDropdown = () => {
		setIsOpen(!isOpen);
	};

	const handleRequestOutput = () => {
		onRequestOutput();
		setIsOpen(false);
	};

	const handleLeaveRoom = () => {
		onLeaveRoom();
		setIsOpen(false);
	};

	return (
		<div className="dropdown" ref={dropdownRef}>
			<button
				className="btn btn-outline-secondary d-flex align-items-center"
				type="button"
				onClick={toggleDropdown}
				style={{
					border: 'none',
					background: 'transparent',
					padding: '8px 12px',
					borderRadius: '20px',
					transition: 'background-color 0.2s',
				}}
				onMouseEnter={(e) => {
					e.target.style.backgroundColor = '#f8f9fa';
				}}
				onMouseLeave={(e) => {
					e.target.style.backgroundColor = 'transparent';
				}}
			>
				<div
					className="status-dot mr-2"
					style={{
						width: '10px',
						height: '10px',
						borderRadius: '50%',
						backgroundColor: isIdle ? '#ffc107' : '#28a745',
						display: 'inline-block',
					}}
					title={isIdle ? 'Idle' : 'Active'}
				></div>
				<span className="text-dark font-weight-medium">{username}</span>
				<svg
					className="ml-2"
					width="12"
					height="12"
					viewBox="0 0 12 12"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
					style={{
						transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
						transition: 'transform 0.2s',
					}}
				>
					<path
						d="M3 4.5L6 7.5L9 4.5"
						stroke="currentColor"
						strokeWidth="1.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>
			</button>

			{isOpen && (
				<div
					className="dropdown-menu show"
					style={{
						position: 'absolute',
						top: '100%',
						right: 0,
						left: 'auto',
						zIndex: 1000,
						minWidth: '280px',
						maxWidth: 'calc(100vw - 16px)',
						overflowWrap: 'break-word',
						padding: '12px',
						border: '1px solid #dee2e6',
						borderRadius: '8px',
						backgroundColor: '#fff',
						boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
						marginTop: '4px',
					}}
				>
					{/* Audio Controls Section */}
					<div className="dropdown-section mb-3">
						<h6 className="dropdown-header px-0 mb-2">Audio Settings</h6>

						<div className="custom-control custom-switch mb-2">
							<input
								type="checkbox"
								className="custom-control-input"
								id="dropdownAudioOutput"
								checked={audioOutputEnabled}
								onChange={toggleAudioOutput}
							/>
							<label
								className="custom-control-label"
								htmlFor="dropdownAudioOutput"
							>
								Audio Output
							</label>
						</div>

						<div className="custom-control custom-switch">
							<input
								type="checkbox"
								className="custom-control-input"
								id="dropdownAudioInput"
								checked={audioInputEnabled}
								onChange={toggleAudioInput}
							/>
							<label
								className="custom-control-label"
								htmlFor="dropdownAudioInput"
							>
								Audio Input
							</label>
						</div>
					</div>

					<hr className="my-2" />

					{/* Action Buttons Section */}
					<div className="dropdown-section">
						<h6 className="dropdown-header px-0 mb-2">Actions</h6>

						<button
							className="btn btn-outline-primary btn-sm btn-block mb-2"
							onClick={handleRequestOutput}
							disabled={isRequestingOutput}
						>
							{isRequestingOutput ? (
								<>
									<span
										className="spinner-border spinner-border-sm mr-2"
										role="status"
										aria-hidden="true"
									></span>
									Sending...
								</>
							) : (
								'Request Output'
							)}
						</button>

						<button
							className="btn btn-outline-danger btn-sm btn-block"
							onClick={handleLeaveRoom}
						>
							Logout
						</button>
					</div>
				</div>
			)}
		</div>
	);
};

export default UserDropdown;
